import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheckIcon, CheckCircle2Icon, LockKeyholeIcon, ScaleIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <header className="border-b border-white/10" data-id="element-82" data-mp="9ka2qpx8ocsp">
      <section className="relative mx-auto max-w-6xl overflow-hidden px-5 pb-12 pt-7 text-center md:px-8 md:pb-16 md:pt-10" data-id="element-83" data-mp="9ipax82b77yj">
        <div className="mx-auto mb-5 flex w-fit items-center gap-2 border border-accent/40 bg-accent/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-accent" data-id="element-84" data-mp="129h0hmovcycw">
          <ScaleIcon size={15} aria-hidden="true" data-id="element-85" data-mp="x8b7dnrar92u" />
          Conversion Elite™
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} data-id="element-86" data-mp="s9gji7eh2ubv">
          <h1 className="mx-auto max-w-4xl font-bold text-white md:text-6xl text-[24px] font-[Poppins,_sans-serif]" data-id="element-87" data-mp="381nrczkpyaz7">
            Todo lo que necesitás para aplicar la{' '}
            <span className="text-accent" data-id="element-88" data-mp="3o7vj9hzbpjw8">Reforma Laboral 2026</span>,{' '}
            <span className="text-accent" data-id="element-89" data-mp="39acuifmnb6os">listo para usar</span>.
          </h1>
          <div className="mx-auto mt-6 max-w-md md:max-w-lg" data-id="element-90" data-mp="39cfofaqx5jys">
            <img src="https://cdn.magicpatterns.com/uploads/3VSNve3Zxmbe4C2bifjmbd/9048ecd7-c6d8-423b-8a58-339a9081d34e.png" alt="Sistema Documental Laboral 2026 con más de 100 modelos editables y categorías de documentos" className="w-full drop-shadow-2xl" data-id="element-91" data-mp="3e84nlcz10yuk" />
          </div>
        </motion.div>

        <motion.a href="#adquirir" whileHover={{
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="mt-8 inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(183,142,69,0.2)] transition-colors hover:bg-[#d2ae6e] focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-ink md:text-base bg-[#4BB745]" data-id="element-92" data-mp="2viy25i6ult52">
          Quiero mi tratado ahora
          <BookOpenCheckIcon size={19} aria-hidden="true" data-id="element-93" data-mp="najhbnrq6df0" />
        </motion.a>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-stone-400 md:text-sm" data-id="element-94" data-mp="ibgnz0l3xvmv">
          <span className="inline-flex items-center gap-1.5" data-id="element-95" data-mp="deq74b1haw0e">
            <CheckCircle2Icon size={15} className="text-accent" aria-hidden="true" data-id="element-96" data-mp="1b1fel0eya0tn" />
            Acceso inmediato
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-97" data-mp="112pz1eaj0sgk">
            <LockKeyholeIcon size={15} className="text-accent" aria-hidden="true" data-id="element-98" data-mp="110wovp0pfq3t" />
            Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-99" data-mp="3ltqe5h5gv3vm">
            <ShieldCheckIcon size={15} className="text-accent" aria-hidden="true" data-id="element-100" data-mp="3hrllakmueba1" />
            Garantía de 7 días
          </span>
        </div>
      </section>
    </header>;
}